import Navbar from '../../components/Navbar';
import AddItem from '../../components/AddItem';
import { Freezer, FridgeLevel, FridgeDoor, Pantry, SpiceRack, FreezerDoor, CrisperLeft, CrisperRight, Other } from '../../components/Containers';

const Fridge = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <AddItem />

      <div className="flex flex-col md:flex-row max-w-7xl mx-auto mt-4 px-2 md:px-6 h-[80vh] md:h-[calc(100vh-64px)] gap-4">

        {/* Left Side */}
        <div className="flex flex-col md:w-1/4 h-full gap-4">
          <div className="bg-orange-900 shadow rounded p-2 flex-[0_0_50%]">
            <Pantry />
          </div>
          <div className="bg-orange-900 shadow rounded p-2 flex-[0_0_10%]">
            <SpiceRack />
          </div>
          <div className="bg-orange-900 shadow rounded p-2 flex-[0_0_25%]">
            <Other />
          </div>
        </div>

        {/* Middle Stack */}
        <div className="flex flex-col md:w-1/2 h-full gap-4">
          <div className="bg-gray-300 shadow rounded p-2 flex-[0_0_20%]">
            <Freezer />
          </div>
          <div className="bg-gray-300 shadow rounded p-2 flex-[0_0_45%]">
            <FridgeLevel />
          </div>
          <div className="flex gap-4 flex-[0_0_20%]">
            <div className="bg-gray-300 shadow rounded p-2 flex-1">
              <CrisperLeft />
            </div>
            <div className="bg-gray-300 shadow rounded p-2 flex-1">
              <CrisperRight />
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="flex flex-col md:w-1/4 h-full gap-4">
          <div className="bg-gray-300 shadow rounded p-2 flex-[0_0_20%]">
            <FreezerDoor />
          </div>
          <div className="bg-gray-300 shadow rounded p-2 flex-[0_0_67%]">
            <FridgeDoor />
          </div>
          <div className="flex-1"></div> {/* Fill remaining space if needed */}
        </div>

      </div>
    </div>
  );
}

export default Fridge;